var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41085",
    "data-name": "Group 41085",
    transform: "translate(-153 -339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41016",
    "data-name": "Group 41016",
    transform: "translate(-11.618 204.382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_717",
    "data-name": "Ellipse 717",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(164.618 134.618)",
    fill: "#e9dfdf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_716",
    "data-name": "Ellipse 716",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(167.618 137.618)",
    fill: "#2bc7c9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "checkmark3",
    d: "M29,8.531,26.864,6.4a1.006,1.006,0,0,0-1.423,0l-12.8,12.8L6.56,13.062a1.006,1.006,0,0,0-1.423,0L3,15.2a1.006,1.006,0,0,0,0,1.423L11.927,25.6a1.006,1.006,0,0,0,1.423,0L29,9.954a1.006,1.006,0,0,0,0-1.423Z",
    transform: "translate(172.292 357.897)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiSuccess);
export default __webpack_public_path__ + "static/media/apiSuccess.2748a2aeb849d17137fa53733d82621d.svg";
export { ForwardRef as ReactComponent };